import React, { useDebugValue, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Modal, Divider, Button, Input, Breadcrumb } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import '../../css/regimen.scss'
import { Redirect, useHistory, useLocation, useParams } from 'react-router'
import { assignDevices, assignPlan, getAllDevices, getDeviceSchedule } from '../../store/action/device.action'
import {
  setNewPatient,
  addCustomPatient,
} from '../../store/action/patient.action'
import { updateDeviceSchedule } from '../../store/action/device.action'
import DeviceEditCard from './device.edit.card'
import serviceInterface from '../../services/service.interface'
import AddDevice from './device.select'
import _, {hasIn, isEmpty } from 'lodash'
import { constants } from '../../constants'
import { tuple } from 'antd/lib/_util/type'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import moment from 'moment'
import { getHelp, pages } from '../../tutorials'

const EditDeviceForm = (props) => {
  var location = useLocation()
  var history = useHistory()
  const params = useParams()
  var [editpage, setEditPage] = useState(
    window.location.pathname.includes('deviceschedule')
  )
  var [isEdited, setIsEdited] = useState(false)
  var [hide, setHide] = useState(false)
  // Per-patient Progress-Test weekly goal overrides, edited via the TracPatch
  // row's modal. null = untouched this session (fall back to the patient's
  // loaded value); an array = the clinician's edits to persist on SAVE.
  var [progressGoals, setProgressGoals] = useState(null)
  const effectiveProgressGoals =
    progressGoals != null
      ? progressGoals
      : (props.newPatient && props.newPatient.progressTestGoalOverrides) || []
  const handleProgressGoalsChange = (overrides) => {
    setProgressGoals(overrides || [])
    setIsEdited(true)
  }
  useEffect(() => {
    props.setNewPatient(location.state?.patient)
    location.state?.assignedDevices?.length > 0
      ? props.assignPlan(location.state?.assignedPlan)
      : (location.state.assignedDevices = props.assignedDevices)
    getHelp(pages.DEVSCHED)
  }, [])

  useEffect(() => {
    location.state?.assignedDevices?.length > 0
      ? props.assignPlan(location.state?.assignedPlan)
      : (location.state.assignedDevices = props.assignedDevices)
  }, [props.assignedDevices])

  useEffect(() => {
    // console.log('wwerr',props.newPatient, props.patient)
    props.getDeviceSchedule(location.state?.patient?._id)
    props.getAllDevices({
      age_group: props.newPatient?.age || props.patient?.age ,
      surgery_type: props.newPatient?.surgery?.type || props.patient?.surgery?.type,
      gender: props.newPatient?.gender || props.patient?.gender,
      careplan: props.newPatient?.careplan || props.patient?.careplan
    })
  },[] )

  useEffect(() => {
    if (editpage) return
    let newList = props.assignedDevices?.map(d => {
      let ex_dev = props.devices.find(e => e._id == d._id)
      if (ex_dev) {
        return {
          // ...d, scheduled_criteria: ex_dev.scheduled_criteria
          ...d, scheduled_criteria:{...ex_dev.scheduled_criteria,skiponsurgerydate:(ex_dev.scheduled_criteria.skiponsurgerydate||d.scheduled_criteria.skiponsurgerydate)}
        }
      }
      return d
    })
    props.assignDevices(newList)
  }, [props.devices, editpage])

  const PatientCreatedBox = (devlen) => {
    Modal.confirm({
      title:
        devlen > 0 ? (
          <div>
            <b>{`${devlen} devices ordered for the new patient ${_.upperFirst(props.newPatient?.firstname)} ${_.upperFirst(props.newPatient?.lastname)}. `}</b>
          </div>
        ) : (
          'Patient created Successfully'
        ),
      icon: <ExclamationCircleOutlined />,
      content: devlen > 0 ? constants.MESSAGE.ORDER_PLACED : '',
      okText: 'Ok',
      cancelButtonProps: { hidden: 'true' },
    })
  }
  var showConfirmBox = (msg) => {
    Modal.confirm({
      title: 'Are you sure you want to leave this page?',
      icon: <ExclamationCircleOutlined />,
      content: msg,
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleBack,
    })
  }

  var handleBack = () => {
    props.assignPlan({})
    props.assignDevices([])
    editpage
      ? history.push('/patient/' + params.id)
      : history.push({
          pathname: '/patient/add/careplan',
          state: { patient: props.newPatient },
        })
  }
  const verifyPatient = (patient) => {

    const find = (obj, key) => !isEmpty(obj) ? _.get(obj, key, null) : null

    let patientObj = patient ? {...JSON.parse(JSON.stringify(patient))} : {}

    if(!hasIn(patientObj, '_id'))
      patientObj._id =  find(props.patient, '_id') || find(location.state?.patient, '_id')

    if(!hasIn(patientObj, 'surgery'))
      patientObj.surgery =  find(props.patient, 'surgery') || find(location.state?.patient, 'surgery')

    if(!hasIn(patientObj, 'careplan'))
      patientObj.careplan =  find(props.patient, 'careplan') || find(location.state?.patient, 'careplan')

    if(!hasIn(patientObj, 'dailyshift'))
      patientObj.dailyshift =  find(props.patient, 'dailyshift') || find(location.state?.patient, 'dailyshift')

    return JSON.parse(JSON.stringify(patientObj))
  }

  var handleNext = async () => {
    const devlist = props.assignedDevices.filter(
      (i) => i.scheduled_criteria != null
    )
    if (editpage) {
      try {
        const patientObj = verifyPatient(props.newPatient)
        // Attach Progress-Test goal overrides only when edited this session, so
        // an unrelated schedule save never clobbers them. Sanitize rows to the
        // ProgressTestGoalWeekIn shape (drop any GraphQL __typename).
        if (progressGoals != null) {
          patientObj.progressTestGoalOverrides = progressGoals.map((g) => ({
            week: g.week,
            extension: g.extension,
            flexion: g.flexion,
          }))
        }
        console.log(patientObj,'2editpage')

        // let _id = props.newPatient._id || props.patient._id || location.state?.patient?._id
        var response = await props.updateDeviceSchedule(
          // {...props.newPatient, _id},
          {...patientObj},
          props.assignedDevices
        )
        if (response) {
          props.assignDevices([])
          history.push('/patient/' + props.newPatient._id)
        }
      } catch (err) {console.log(err,'device edit handleNext')}
    } else if (
      props.plan.include_regimens != undefined &&
      props.plan.include_regimens
    ) {
      history.push({
        pathname: '/patient/add/regimens',
        state: {
          patient: props.newPatient,
          devices: props.devices,
          assignedPlan: props.plan,
          assignedDevices: props.assignedDevices,
        },
      })
    } else {
      history.push({
        pathname: '/patient/add/questionnaire',
        state: {
          patient: props.newPatient,
          devices: props.devices,
          assignedPlan: props.plan,
          assignedDevices: props.assignedDevices,
        },
      })
    }

    //     else if(props.plan.include_regimens!=undefined && !props.plan.include_regimens){
    //        try {
    //            var response = await props.addPatient({ ...props.newPatient, careplan: props.plan._id, include_regimens: props.plan.include_regimens }, devlist, []);
    //            if (response)
    //            {
    //                PatientCreatedBox(props.assignedDevices?.length);
    //                props.assignDevices([]);
    //                history.push('/patient')}
    // }
    // catch(err){
    //     alert('Something went wrong')
    // }
    // }
  }
  const handleRemoveClick = (id) => {
    const deviceList = serviceInterface
      .DeviceService()
      .removeDevice(id, props.assignedDevices)
    props.assignDevices(deviceList)
    setIsEdited(true)
  }
  const changeSchedule = async (dev) => {
    var devindex = 0
    const deviceList = [...props.assignedDevices].forEach((i, index) => {
      if (i._id == dev._id) devindex = index
      return {}
    })
    const newList = await serviceInterface
      .DeviceService()
      .changeSchedule([...props.assignedDevices], devindex, dev)
    props.assignDevices(newList)

  }

  const changeScheduleAndSkipToAll = (dev) => {
    let devlist = [...props.assignedDevices]; 
    devlist[_.findIndex(devlist, {_id:dev._id})] = dev

    devlist.forEach(async (i, index) => {
      devlist = await serviceInterface
        .DeviceService()
        .changeSchedule(devlist, index, {
          ...i,
          scheduled_criteria: { ...i.scheduled_criteria, skiponsurgerydate: true },
        })
    })
    props.assignDevices(devlist)
    

  }

  const changeScheduleToAll = async (dev) => {
    var newList = [...props.assignedDevices]
    const deviceList = [...props.assignedDevices].forEach(async (i, index) => {
      let sched_criteria = dev.scheduled_criteria
      newList = await serviceInterface
        .DeviceService()
        .changeSchedule(newList, index, {
          ...i,
          scheduled_criteria: {...sched_criteria},
        })
    })
    props.assignDevices(newList)
  }

  const renderDeviceSchedule = () => {
    return [...props.assignedDevices]?.map((dev) => {
      return (
        <DeviceEditCard
          handleRemoveClick={handleRemoveClick}
          patient={props.newPatient}
          changeSchedule={changeSchedule}
          changeScheduleToAll={changeScheduleToAll}
          changeScheduleAndSkipToAll={changeScheduleAndSkipToAll}
          device={dev}
          isEdited={() => setIsEdited(true)}
          buttonHide={hide}
          hideButtons={setHide}
          editpage={editpage}
          progressGoals={effectiveProgressGoals}
          onProgressGoalsChange={handleProgressGoalsChange}
        />
      )
    })
  }

  return (
    <Col className='patientAddContainer'>
      {editpage && (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/patient'>Patients</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Devices</Breadcrumb.Item>
        </Breadcrumb>
      )}
      {!location.state?.patient?.age && !props.newPatient && (
        <Redirect to='/patient/add/info' />
      )}
      <Row align='middle' className='headerRow divide scheduleHeaderCont'>
        <Row align='middle' className='headerRow divide scheduleHeaderCont'>
          <Col className='headerText scheduleHeader'>
            DEVICE SCHEDULE ( {_.upperFirst(props.newPatient?.firstname)}{' '}
            {_.upperFirst(props.newPatient?.lastname)} -{' '}
            <span
              style={{ fontSize: '17px' }}
            >{` Surgery Date: ${moment(props.newPatient?.surgery?.date).format('MM/DD/YYYY')}`}</span>{' '}
            )
          </Col>
        </Row>
      </Row>

      <Row>
        <Col flex={'auto'}>
          <Row
            hidden={hide}
            style={{ paddingTop: '15px', alignItems: 'center' }}
          >
            <Col className='exerciseCol ' flex={'25%'}>
              <Row justify='start'>
                <AddDevice
                  assignedDevices={props.assignedDevices}
                  devices={props.devices}
                  isEdited={() => setIsEdited(true)}
                  assignDevices={props.assignDevices}
                  surgeryDate={props.newPatient?.surgery?.date || props.patient?.surgery?.date}
                />
              </Row>
            </Col>
            <Col flex={'25%'}></Col>
            <Col className='exerciseCol ' flex={'50%'}>
              <Row justify='end' gutter={40}>
                <Col>
                  <Button
                    onClick={() =>
                      editpage
                        ? isEdited
                          ? showConfirmBox(
                              'Your changes will be lost if you go back.'
                            )
                          : handleBack()
                        : showConfirmBox(
                            'Your changes will be lost if you go back.'
                          )
                    }
                    className={'nextBtn'}
                  >
                    BACK
                  </Button>
                </Col>
                <Col>
                  {/* <Button onClick={handleNext}disabled={(editpage?(( isEdited)?false:true):false)} className={"nextBtn"}>{editpage? "SAVE":(props.plan?.include_regimens ? "NEXT":"CREATE")}</Button> */}
                  <Button
                    onClick={handleNext}
                    disabled={editpage ? (isEdited ? false : true) : false}
                    className={'nextBtn'}
                  >
                    {editpage ? 'SAVE' : 'NEXT'}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Col flex={'auto'}>
        <Row
          style={{
            backgroundColor: '#f0f0f0',
            fontSize: '18px',
            padding: '24px',
          }}
        >
          <Col flex={'20%'}>
            <Row className='' justify='center'>
              DEVICES
            </Row>
          </Col>
          <Col flex={'50%'}>
            <Row className='' justify='center'>
              SCHEDULE
            </Row>
          </Col>
          <Col flex={'30%'}>
            <Row style={{ paddingLeft: 0 }} justify='center'>
              ACTIONS
            </Row>
          </Col>
        </Row>
      </Col>
      <Row className='regContainer'>
        <Col flex={'auto'} className='formBody'>
          {renderDeviceSchedule()}
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />
      <Row>
        <Col flex={'auto'}>
          <Row
            hidden={hide}
            style={{ paddingTop: '15px', alignItems: 'center' }}
          >
            <Col className='exerciseCol ' flex={'25%'}>
              <Row justify='start'>
                <AddDevice
                  assignedDevices={props.assignedDevices}
                  devices={props.devices}
                  isEdited={() => setIsEdited(true)}
                  assignDevices={props.assignDevices}
                  surgeryDate={props.newPatient?.surgery?.date || props.patient?.surgery?.date}
                />
              </Row>
            </Col>
            <Col flex={'25%'}></Col>
            <Col className='exerciseCol ' flex={'50%'}>
              <Row justify='end' gutter={40}>
                <Col>
                  <Button
                    onClick={() =>
                      editpage
                        ? isEdited
                          ? showConfirmBox(
                              'Your changes will be lost if you go back.'
                            )
                          : handleBack()
                        : showConfirmBox(
                            'Your changes will be lost if you go back.'
                          )
                    }
                    className={'nextBtn'}
                  >
                    BACK
                  </Button>
                </Col>
                <Col>
                  {/* <Button onClick={handleNext}disabled={(editpage?(( isEdited)?false:true):false)} className={"nextBtn"}>{editpage? "SAVE":(props.plan?.include_regimens ? "NEXT":"CREATE")}</Button> */}
                  <Button
                    id={'savedevsched'}
                    onClick={handleNext}
                    disabled={editpage ? (isEdited ? false : true) : false}
                    className={'nextBtn'}
                  >
                    {editpage ? 'SAVE' : 'NEXT'}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}

EditDeviceForm.propTypes = {
  company: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    newPatient: state.patient.newpatient,
    devices: state.device.devices,
    plan: state.device.assignedPlan,
    assignedDevices: state.device.assignedDevices,
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
    assignDevices: (devices) => dispatch(assignDevices(devices)),
    addPatient: (patient, devices, exercises) =>
      dispatch(addCustomPatient({ patient, devices, exercises })),
    assignPlan: (plan) => dispatch(assignPlan(plan)),
    updateDeviceSchedule: (patient, devices) =>
      dispatch(updateDeviceSchedule({ patient, devices })),
    getAllDevices: (patient) =>
      dispatch(
        getAllDevices(patient)
      ),
    getDeviceSchedule: (patientid) => dispatch(getDeviceSchedule(patientid)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDeviceForm)
